export const cart = {
  cart: "Cart",
  cartItems: "Cart Items",
  quantity: "Quantity",
  delete: "Delete",
  summary: "Summary",
  productsValue: "Products Value",
  total: "Total",
  numOfProducts: "Number of Products",
  yourCartIsEmpty: "Your Cart is Empty",
  checkout: "Checkout",
  // Checkout page translations
  contactInformation: "Contact Information",
  firstName: "First Name",
  enterFirstName: "Enter first name",
  lastName: "Last Name",
  enterLastName: "Enter last name",
  email: "Email",
  enterEmail: "Enter email address",
  phone: "Phone",
  enterPhone: "Enter phone number",
  billingInformation: "Billing Information",
  address: "Address",
  enterAddress: "Enter address",
  city: "City",
  enterCity: "Enter city",
  postalCode: "Postal Code",
  enterPostalCode: "Enter postal code",
  country: "Country",
  enterCountry: "Enter country",
  corporateInformation: "Corporate Information",
  companyName: "Company Name",
  enterCompanyName: "Enter company name",
  vatNumber: "VAT Number",
  enterVatNumber: "Enter VAT number",
  paymentInformation: "Payment Information",
  cardNumber: "Card Number",
  cardHolderName: "Card Holder Name",
  enterCardHolderName: "Enter card holder name",
  expiryDate: "Expiry Date",
  cvv: "CVV",
  orderSummary: "Order Summary",
  subtotal: "Subtotal",
  shipping: "Shipping",
  proceedToPayment: "Proceed to Payment",
  backToCart: "Back to Cart",
  paymentProcessed: "Payment processed successfully!",
  // ===============================================================
};
